import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const buttonLoaderFn = /* @__PURE__ */ createRecipe('button-loader', {}, [])

const buttonLoaderVariantMap = {}

const buttonLoaderVariantKeys = Object.keys(buttonLoaderVariantMap)

export const buttonLoader = /* @__PURE__ */ Object.assign(memo(buttonLoaderFn.recipeFn), {
  __recipe__: true,
  __name__: 'buttonLoader',
  __getCompoundVariantCss__: buttonLoaderFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: buttonLoaderVariantKeys,
  variantMap: buttonLoaderVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, buttonLoaderVariantKeys)
  },
  getVariantProps: buttonLoaderFn.getVariantProps,
})